



























































import { Component, Vue } from 'vue-property-decorator';
import router from '../router';
import users from '@/store/modules/users';
import addresses from '@/store/modules/addresses';
import controllers from '@/store/modules/controllers';
import subscriptions from '@/store/modules/subscriptions';
import CController from '@/components/CController.vue';
import { Address, Controller } from '@/store/models';
import store from '../store/store';

enum addrDlgMode {
    Add = 1,
    Edit,
}

@Component({
  components: {
    CController,
  },
})
export default class VControllers extends Vue {
  private alerts: Array<{type: string, msg: string}> = [];
  private editDlg: boolean = false;
  private inprogress: boolean = false;

  private beforeMount() {
    if (!store.getters.loggedIn) {
      router.replace('/login');
    }
  }

  private created() {
    if (store.getters.loggedIn) {
      this.inprogress = true;
      controllers.refreshControllers(store.getters.user.id)
        .catch((error: any) => {
          this.alerts.push({type: 'error', msg: 'Не удалось обновить список контроллеров. ' +
            'Ошибка на сервере или плохое соединение с интернетом.'});
        })
        .finally(() => {
          this.inprogress = false;
        });

      addresses.refreshAddresses(store.getters.user.id)
        .catch((error: any) => {
          this.alerts.push({type: 'error', msg: 'Не удалось обновить список адресов.'});
        });

      // controllers.refreshCounters(store.getters.user.id)
      //   .catch((error: any) => {
      //     this.alerts.push({type: 'error', msg: 'Не удалось обновить список счетчиков.'});
      //   });

      // subscriptions.refreshEmailSubscriptions(store.getters.user.id)
      //   .catch((error: any) => {
      //     this.alerts.push({type: 'error', msg: 'Не удалось обновить список подписок.'});
      //   });

      // subscriptions.refreshMosruSubscriptions(store.getters.user.id)
      //   .catch((error: any) => {
      //     this.alerts.push({type: 'error', msg: 'Не удалось обновить список подписок.'});
      //   });
    }
  }

  // private destroyed() {
  //   console.log('controllers view destroyed');
  // }

  get addressesList(): string[] {
    const addrList: string[] = [];
    addresses.addresses.forEach((addr) => {
      addrList.push(`${addr.city}, ${addr.street}, ${addr.house}/${addr.building ? addr.building : ''}, ${addr.flat}`);
    });
    return addrList;
  }

  get controllers() {
    return controllers.getControllers;
  }

  get loggedIn() {
    return store. getters.loggedIn;
  }

  private openEditControllers(ctrl: Controller) {
    // this.mode = addrDlgMode.Edit;
    this.editDlg = true;
    // if (addresses.addresses) {
    //   addresses.addresses.forEach((el) => {
    //     if (el.id == id) {
    //       this.editAddr = { ...el };
    //     }
    //   });
    // }
  }

  private saveAddress() {
    this.editDlg = false;
    // this.inprogress = true;
    // addresses.saveOrAddAddress({ ...this.editAddr })
    //   .then((addr) => {
    //     if (addr != null) {
    //     this.alerts.push({id: this.alertId++, type: 'success', msg: 'Изменения в адресе успешно сохранены.'});
    //     }
    //   })
    //   .catch((error: any) => {
    //     this.alerts.push({id: this.alertId++, type: 'error', msg: 'Не удалось сохранить адрес.'});
    //     //   console.log(error);
    //   })
    //   .finally(() => {
    //     this.inprogress = false;
    //   });
  }
}
